if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();

      document.dispatchEvent(new CustomEvent('modal-closed', {
        bubbles: true,
        composed: true
      }));
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const thumbnails = this.querySelector('[id^="ProductModal-GalleryThumbnails"]');
      const slider = this.querySelector('[id^="ProductModal-Slider-Thumbnails"]');
      const viewer = this.querySelector('[id^="ProductModal-GalleryViewer"]');
      const prevButton = this.querySelectorAll('button.gallery-button-modal[name="previous-slide"]');
      const nextButton = this.querySelectorAll('button.gallery-button-modal[name="next-slide"]');

      document.dispatchEvent(new CustomEvent('modal-thumbnails-ready', {
        detail: { thumbnails, slider, viewer, prevButton, nextButton },
      }));
    }
  });
}
